<template>
    <div class="data-wrapper-core">
        <template v-if="!hideHeader">
            <h3>Stripe</h3>
            <v-divider></v-divider>
        </template>
        <h4>Stripe-CustomerID:</h4>
        <a>{{ agency.stripeCustomerID }}<v-btn :href="`https://dashboard.stripe.com/customers/${agency.stripeCustomerID}`" flat size="20" class="agency-dialog-stripe-link-button" target="_blank"><v-icon>mdi-open-in-new</v-icon></v-btn></a>
        <h4>Stripe-Subscription-Info:</h4>
        <h4>Subscription-ID:</h4>
        <p>{{ agency.stripeSubscriptionInfo.subID }}</p>
        <h4>Billing Period:</h4>
        <p>{{ agency.stripeSubscriptionInfo.billingPeriod }}</p>
        <h4>Payment Status:</h4>
        <p :style="{color: agency.stripeSubscriptionInfo.paymentStatus === 'trial' ? 'green' : '' }">{{ agency.stripeSubscriptionInfo.paymentStatus }}</p>
        <h4>Cancelled:</h4>
        <p>{{ agency.stripeSubscriptionInfo.cancelled }}</p>
        <h4>Bounced Payment Counter:</h4>
        <p>{{ agency.stripeSubscriptionInfo.bouncedPaymentCounter }}</p>
        <h4>Date of Cancel:</h4>
        <p>{{ agency.stripeSubscriptionInfo.dateOfCancel }}</p>
    </div>
</template>

<script>
export default {
    props: {
        agency: {
            type: Object,
            required: true
        },
        hideHeader: { type: Boolean, default: false }
    }
};
</script>

<style lang="scss" scoped>


.agency-dialog-stripe-link-button {
    margin-left: 12px;
    background-color: inherit;
}

</style>